import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { FullComponent } from './layouts/full/full.component';
import { BlankComponent } from './layouts/blank/blank.component';

import { FvmsApiAuthGuard } from "./shared/service";
import { FvmsApiReverseAuthGuard } from "./shared/service";
import {
    AuthLoginComponent
    ,AuthExtLoginComponent
    ,AuthExtErrE401Component
    ,FvmsDownloadEtasMainComponent
    ,InstallMainComponent
} from "./fvms";

import {
  DtgAnalyticsDashboardComponent
  , DtgAnalyticsDriveSafeSummaryComponent
  , DtgAnalyticsDriveSafeEcoComponent //Deprecated
  , DtgAnalyticsDriveSafeSafetyComponent
  , DtgCarLastTotalComponent
  , DtgConfigSystemComponent
  , DtgDownloadCalendarComponent
  , DtgDownloadEtasRequestMainComponent
  , DtgManageCarMainComponent
  , DtgManageCarExtAcceptMainComponent
  , DtgManageCarExtMainMainComponent
  , DtgManageCompanyMainComponent
  , DtgManageDangerDriveRuleMainComponent
  , DtgManageEtasCarMainComponent
  , DtgManageEtasFileMainComponent
  , DtgManageDriverMainComponent
  , GeofenceConfMainComponent
  , DtgGeofenceCarMainComponent
  , GeofenceRouteMainComponent
  , DtgManageNoticeMainComponent
  , DtgManageScheduleDriveMainComponent
  , DtgManageTeamMainComponent
  , DtgManageUserMainComponent
  , DtgManageMainComponent
  , DtgNoticeMainComponent
  , DtgPacketRealtimeComponent
  , DtgReportCarAllComponent
  , DtgReportCarDetailComponent
  , DtgReportCarTripDetailComponent
  , DtgReportCarMonthMainComponent
  , DtgReportCarMonthDailyComponent
  , DtgReportCarTemperMainComponent
  , DtgReportCarTemperDailyComponent
  , DtgReportCarTemperDetailComponent
  , ReportGeofenceHisMainComponent
  , DtgReportRestDayScheduleComponent
  , DtgReportRestDriveScheduleAllComponent
  , DtgReportDangerDayMainComponent
  , DtgAnalyticsDriveDangerStopHighRpmMainComponent
  , DtgCarExtDriveHistComponent
  , DtgTestT01Component
  , DtgTestT02Component
  , DtgTestT03Component
  , DtgAnalyticsDriveCarbonMainComponent
} from "./dtg";

export const Approutes: Routes = [
    {
        path: ""
        ,component: BlankComponent
        // ,canActivateChild: [ FvmsApiReverseAuthGuard ]
        ,children: [
            { path: '', redirectTo: '/fvms/auth/login/main', pathMatch: 'full' }
            ,{
                path: 'fvms/auth/login/main'
                ,component: AuthLoginComponent
                ,canActivateChild: [ FvmsApiReverseAuthGuard ]
            }
            ,{
                path: 'fvms/auth/ext/login/main'
                ,component: AuthExtLoginComponent
                ,canActivateChild: [ FvmsApiReverseAuthGuard ]
            }
            ,{
                path: 'fvms/auth/ext/err/e401/main'
                ,component: AuthExtErrE401Component
                ,canActivateChild: [ FvmsApiReverseAuthGuard ]
            }
            ,{
                path: 'fvms/download/etas/main'
                ,component: FvmsDownloadEtasMainComponent
                ,canActivateChild: [ FvmsApiReverseAuthGuard ]
            }
            ,{
                path: 'fvms/install'
                ,component: InstallMainComponent
                ,canActivateChild: [ FvmsApiReverseAuthGuard ]
            }
            ,{
                path: "dtg/car/ext/current/drive/hist/list"
                ,component: DtgCarExtDriveHistComponent
                ,canActivateChild: [ FvmsApiAuthGuard ]
            }
        ]
    }
    ,{
        path: ''
        ,component: FullComponent
        ,canActivateChild: [ FvmsApiAuthGuard ]
        ,children: [
            { path: '', redirectTo: '/dtg/car/current/list', pathMatch: 'full' }
            // ,{
            //     path: 'starter'
            //     ,loadChildren: () => import('./starter/starter.module').then(m => m.StarterModule)
            // }
            ,{
                path: "dtg/car/current/list"
                ,component: DtgCarLastTotalComponent
                ,data: {
                    title: '메인'
                    ,urls: [
                        {
                            title: '메인'
                            ,url:"/dtg/car/current/list"
                        }
                    ]
                    ,isShowDateSelector: true
                    ,sideBarType:"carList"
                    ,menuId: "menu-01"
                }
                ,children:[

                ]
            }
            ,{
                path: 'dtg/analytics/dashboard'
                ,component: DtgAnalyticsDashboardComponent
                ,data: {
                    title: '대시보드'
                    ,urls: [
                        {
                            title: '메인'
                            ,url:"/dtg/car/current/list"
                        }
                        ,{ title: '대시보드' }
                    ]
                    ,isShowDateSelector: false
                    ,sideBarType:"menu"
                    ,menuId: "menu-02"
                }
            }
            ,{
                path: "dtg/report/car/all"
                ,component: DtgReportCarAllComponent
                ,data: {
                    title: '일별 차량운행일지'
                    ,urls: [
                        {
                            title: '메인'
                            ,url:"/dtg/car/current/list"
                        }
                        ,{ title: '일별 차량운행일지' }
                    ]
                    ,isShowDateSelector: true
                    ,sideBarType:"menu"
                    ,menuId: "menu-02"
                }
            }
            ,{
                path: "dtg/report/car/detail/:dtgUnitId/:fvmsTripCnt"
                ,component: DtgReportCarTripDetailComponent
                ,data: {
                    title: '트립상세운행일지'
                    ,urls: [
                        {
                            title: '메인'
                            ,url:"/dtg/car/current/list"
                        }
                        ,{
                            title: '일별 차량운행일지'
                            ,url:"/dtg/report/car/all"
                        }
                        ,{
                            title: '지정차량운행일지'
                            ,url:"dtg/report/car/detail/:dtgUnitId"
                        }
                        ,{ title: '트립상세차량운행일지' }
                    ]
                    ,isShowDateSelector: true
                    ,sideBarType:"menu"
                    ,menuId: "menu-02"
                }
            }
            ,{
                path: "dtg/report/car/detail/:dtgUnitId"
                ,component: DtgReportCarDetailComponent
                ,data: {
                    title: '지정차량운행일지'
                    ,urls: [
                        {
                            title: '메인'
                            ,url:"/dtg/car/current/list"
                        }
                        ,{
                            title: '일별 차량운행일지'
                            ,url:"/dtg/report/car/all"
                        }
                        ,{ title: '지정차량운행일지' }
                    ]
                    ,isShowDateSelector: true
                    ,sideBarType:"menu"
                    ,menuId: "menu-02"
                }
            }
            ,{
                path: "dtg/report/car/month/main"
                ,component: DtgReportCarMonthMainComponent
                ,data: {
                    title: '월별 차량운행일지'
                    ,urls: [
                        {
                            title: '메인'
                            ,url:"/dtg/car/current/list"
                        }
                        ,{ title: '월별 차량운행일지' }
                    ]
                    ,isShowDateSelector: false
                    ,sideBarType:"menu"
                    ,menuId: "menu-02"
                }
            }
            ,{
                path: "dtg/report/car/month/daily/:dtgUnitId/:searchYy/:searchMm"
                ,component: DtgReportCarMonthDailyComponent
                ,data: {
                    title: '지정차량 월별 운행일지'
                    ,urls: [
                        {
                            title: '메인'
                            ,url:"/dtg/car/current/list"
                        }
                        ,{
                            title: '월별 차량운행일지'
                            ,url:"/dtg/report/car/month/main"
                        }
                        ,{ title: '지정차량 월별 운행일지' }
                    ]
                    ,isShowDateSelector: false
                    ,sideBarType:"menu"
                    ,menuId: "menu-02"
                }
            }
            ,{
                path: "dtg/report/car/temper/main"
                ,component: DtgReportCarTemperMainComponent
                ,data: {
                    title: '온도기록일지'
                    ,urls: [
                        {
                            title: '메인'
                            ,url:"/dtg/car/current/list"
                        }
                        ,{ title: '온도기록일지' }
                    ]
                    ,isShowDateSelector: false
                    ,sideBarType:"menu"
                    ,menuId: "menu-02"
                }
            }
            ,{
                path: "dtg/report/car/temper/daily/:dtgUnitId/:searchYy/:searchMm"
                ,component: DtgReportCarTemperDailyComponent
                ,data: {
                    title: '지정차량 온도기록일지'
                    ,urls: [
                        {
                            title: '메인'
                            ,url:"/dtg/car/current/list"
                        }
                        ,{
                            title: '온도기록일지'
                            ,url:"/dtg/report/car/temper/main"
                        }
                        ,{ title: '지정차량 온도기록일지' }
                    ]
                    ,isShowDateSelector: false
                    ,sideBarType:"menu"
                    ,menuId: "menu-02"
                }
            }
            ,{
                path: "dtg/report/car/temper/detail/:dtgUnitId/:searchYy/:searchMm/:searchDd"
                ,component: DtgReportCarTemperDetailComponent
                ,data: {
                    title: '온도기록일지 상세'
                    ,urls: [
                        {
                            title: '메인'
                            ,url:"/dtg/car/current/list"
                        }
                        ,{
                            title: '온도기록일지'
                            ,url:"/dtg/report/car/temper/main"
                        }
                        ,{ title: '온도기록일지 상세' }
                    ]
                    ,isShowDateSelector: false
                    ,sideBarType:"menu"
                    ,menuId: "menu-02"
                }
            }
            ,{
                path: "dtg/report/rest/day/schedule"
                ,component: DtgReportRestDayScheduleComponent
                ,data: {
                    title: '일반휴게시간'
                    ,urls: [
                        {
                            title: '메인'
                            ,url:"/dtg/car/current/list"
                        }
                        ,{ title: '일반휴게시간' }
                    ]
                    ,isShowDateSelector: false
                    ,sideBarType:"menu"
                    ,menuId: "menu-02"
                }
            }
            ,{
                path: "dtg/report/rest/drive/schedule/all"
                ,component: DtgReportRestDriveScheduleAllComponent
                ,data: {
                    title: '일반휴게시간'
                    ,urls: [
                        {
                            title: '메인'
                            ,url:"/dtg/car/current/list"
                        }
                        ,{ title: '일반휴게시간' }
                    ]
                    ,isShowDateSelector: false
                    ,sideBarType:"menu"
                    ,menuId: "menu-02"
                }
            }
            ,{
                path: "dtg/report/danger/day/main"
                ,component: DtgReportDangerDayMainComponent
                ,data: {
                    title: '위험운전이력'
                    ,urls: [
                        {
                            title: '메인'
                            ,url:"/dtg/car/current/list"
                        }
                        ,{ title: '위험운전이력' }
                    ]
                    ,isShowDateSelector: true
                    ,sideBarType:"menu"
                    ,menuId: "menu-02"
                }
            }
            ,{
                path: "dtg/analytics/drive/safe/summary"
                ,component: DtgAnalyticsDriveSafeSummaryComponent
                ,data: {
                    title: '안전운전요약'
                    ,urls: [
                        {
                            title: '메인'
                            ,url:"/dtg/car/current/list"
                        }
                        ,{ title: '리포트' }
                        ,{ title: '안전운전요약' }
                    ]
                    ,isShowDateSelector: false
                    ,sideBarType:"menu"
                    ,menuId: "menu-03"
                }
            }
            // ,{
            //     path: "dtg/analytics/drive/safe/eco"
            //     ,component: DtgAnalyticsDriveSafeEcoComponent
            //     ,data: {
            //         title: '경제운전'
            //         ,urls: [
            //             {
            //                 title: '메인'
            //                 ,url:"/dtg/car/current/list"
            //             }
            //             ,{ title: '리포트' }
            //             ,{ title: '경제운전' }
            //         ]
            //         ,isShowDateSelector: false
            //         ,sideBarType:"menu"
            //         ,menuId: "menu-03"
            //     }
            // }
            ,{
                path: "dtg/analytics/drive/safe/safety"
                ,component: DtgAnalyticsDriveSafeSafetyComponent
                ,data: {
                    title: '안전운전'
                    ,urls: [
                        {
                            title: '메인'
                            ,url:"/dtg/car/current/list"
                        }
                        ,{ title: '리포트' }
                        ,{ title: '안전운전' }
                    ]
                    ,isShowDateSelector: false
                    ,sideBarType:"menu"
                    ,menuId: "menu-03"
                }
            }
            ,{
                path: "dtg/analytics/drive/danger/stophighrpm/main"
                ,component: DtgAnalyticsDriveDangerStopHighRpmMainComponent
                ,data: {
                    title: '공회전+고RPM'
                    ,urls: [
                        {
                            title: '메인'
                            ,url:"/dtg/car/current/list"
                        }
                        ,{ title: '리포트' }
                        ,{ title: '공회전+고RPM' }
                    ]
                    ,isShowDateSelector: true
                    ,sideBarType:"menu"
                    ,menuId: "menu-03"
                }
            }
            ,{
                path: "dtg/report/geofence/his/main"
                ,component: ReportGeofenceHisMainComponent
                ,data: {
                    title: '지오펜스출입이력'
                    ,urls: [
                        {
                            title: '메인'
                            ,url:"/dtg/car/current/list"
                        }
                        ,{ title: '리포트' }
                        ,{ title: '지오펜스출입이력' }
                    ]
                    ,isShowDateSelector: true
                    ,sideBarType:"menu"
                    ,menuId: "menu-03"
                }
            }
            ,{
                path: "dtg/download/calendar"
                ,component: DtgDownloadCalendarComponent
                ,data: {
                    title: '제출파일 다운로드'
                    ,urls: [
                        {
                            title: '메인'
                            ,url:"/dtg/car/current/list"
                        }
                        ,{ title: '제출파일 다운로드' }
                    ]
                    ,isShowDateSelector: false
                    ,sideBarType:"menu"
                    ,menuId: "menu-03"
                }
            }
            ,{
              path: "dtg/download/etas/request"
              ,component: DtgDownloadEtasRequestMainComponent
              ,data: {
                title: '제출파일 다운로드'
                ,urls: [
                  {
                    title: '메인'
                    ,url:"/dtg/car/current/list"
                  }
                  ,{ title: '제출파일 다운로드' }
                ]
                ,isShowDateSelector: false
                ,sideBarType:"menu"
                ,menuId: "menu-03"
              }
            }
            ,{
                path: "dtg/analytics/drive/carbon/main"
                ,component: DtgAnalyticsDriveCarbonMainComponent
                ,data: {
                    title: '탄소배출량'
                    ,urls: [
                        {
                            title: '메인'
                            ,url:"/dtg/car/current/list"
                        }
                        ,{ title: '탄소배출량' }
                    ]
                    ,isShowDateSelector : false
                    ,sideBarType:"menu"
                    ,menuId: "menu-03"
                }
            }
            ,{
                path: "dtg/manage/main"
                ,component: DtgManageMainComponent
                ,data: {
                    title: '환경설정'
                    ,urls: [
                        { title: '환경설정' }
                    ]
                    ,isShowDateSelector: false
                    ,sideBarType:"menu"
                    ,menuId: "menu-04"
                }
            }
            ,{
                path: "dtg/manage/company/main"
                ,component: DtgManageCompanyMainComponent
                ,data: {
                    title: '회사정보관리'
                    ,urls: [
                        {
                            title: '메인'
                            ,url:"/dtg/car/current/list"
                        }
                        ,{ title: '회사정보관리' }
                    ]
                    ,isShowDateSelector: true
                    ,sideBarType:"menu"
                    ,menuId: "menu-04"
                }
            }
            ,{
                path: "dtg/manage/team/main"
                ,component: DtgManageTeamMainComponent
                ,data: {
                    title: '그룹관리'
                    ,urls: [
                        {
                            title: '메인'
                            ,url:"/dtg/car/current/list"
                        }
                        ,{ title: '그룹관리' }
                    ]
                    ,isShowDateSelector: false
                    ,sideBarType:"menu"
                    ,menuId: "menu-04"
                }
            }
            ,{
                path: "dtg/manage/car/main"
                ,component: DtgManageCarMainComponent
                ,data: {
                    title: '소속차량관리'
                    ,urls: [
                        {
                            title: '메인'
                            ,url:"/dtg/car/current/list"
                        }
                        ,{ title: '소속차량관리' }
                    ]
                    ,isShowDateSelector: false
                    ,sideBarType:"menu"
                    ,menuId: "menu-04"
                }
            }
            ,{
                path: "dtg/manage/car/ext/main"
                ,component: DtgManageCarExtMainMainComponent
                ,data: {
                    title: '공급차량관리'
                    ,urls: [
                        {
                            title: '메인'
                            ,url:"/dtg/car/current/list"
                        }
                        ,{ title: '공급차량관리' }
                    ]
                    ,isShowDateSelector: false
                    ,sideBarType:"menu"
                    ,menuId: "menu-04"
                }
            }
            ,{
                path: "dtg/manage/car/ext/accept/main/:dtgUnitId"
                ,component: DtgManageCarExtAcceptMainComponent
                ,data: {
                    title: '차량공급승인관리'
                    ,urls: [
                        {
                            title: '메인'
                            ,url:"/dtg/car/current/list"
                        }
                        ,{
                            title: '차량관리'
                            ,url:"/dtg/manage/car/main"
                        }
                        ,{ title: '차량공급승인관리' }
                    ]
                    ,isShowDateSelector: false
                    ,sideBarType:"menu"
                    ,menuId: "menu-04"
                }
            }
            ,{
                path: "dtg/manage/user/main"
                ,component: DtgManageUserMainComponent
                ,data: {
                    title: '사용자관리'
                    ,urls: [
                        {
                            title: '메인'
                            ,url:"/dtg/car/current/list"
                        }
                        ,{ title: '사용자관리' }
                    ]
                    ,isShowDateSelector: false
                    ,sideBarType:"menu"
                    ,menuId: "menu-04"
                }
            }
            ,{
                path: "dtg/manage/driver/main"
                ,component: DtgManageDriverMainComponent
                ,data: {
                    title: '운전자관리'
                    ,urls: [
                        {
                            title: '메인'
                            ,url:"/dtg/car/current/list"
                        }
                        ,{ title: '운전자관리' }
                    ]
                    ,isShowDateSelector: false
                    ,sideBarType:"menu"
                    ,menuId: "menu-04"
                }
            }
            ,{
                path: "dtg/manage/schedule/drive/main"
                ,component: DtgManageScheduleDriveMainComponent
                ,data: {
                    title: '배차관리'
                    ,urls: [
                        {
                            title: '메인'
                            ,url:"/dtg/car/current/list"
                        }
                        ,{ title: '배차관리' }
                    ]
                    ,isShowDateSelector: true
                    ,sideBarType:"menu"
                    ,menuId: "menu-04"
                }
            }
            ,{
                path: "dtg/manage/geofence/conf/main"
                ,component: GeofenceConfMainComponent
                ,data: {
                    title: '지오펜스지역관리'
                    ,urls: [
                        {
                            title: '메인'
                            ,url:"/dtg/car/current/list"
                        }
                        ,{ title: '지오펜스지역관리' }
                    ]
                    ,isShowDateSelector: false
                    ,sideBarType:"menu"
                    ,menuId: "menu-04"
                }
            }
            ,{
                path: "dtg/manage/geofence/car/main"
                ,component: DtgGeofenceCarMainComponent
                ,data: {
                    title: '지오펜스차량관리'
                    ,urls: [
                        {
                            title: '메인'
                            ,url:"/dtg/car/current/list"
                        }
                        ,{ title: '지오펜스차량관리' }
                    ]
                    ,isShowDateSelector: false
                    ,sideBarType:"menu"
                    ,menuId: "menu-04"
                }
            }
            // ,{
            //     path: "dtg/manage/geofence/route/main"
            //     ,component: GeofenceRouteMainComponent
            //     ,data: {
            //         title: '지오펜스경로관리'
            //         ,urls: [
            //             {
            //                 title: '메인'
            //                 ,url:"/dtg/car/current/list"
            //             }
            //             ,{ title: '지오펜스경로관리' }
            //         ]
            //         ,isShowDateSelector: false
            //         ,sideBarType:"menu"
            //         ,menuId: "menu-04"
            //     }
            // }
            ,{
                path: "dtg/manage/danger/drive/rule/main"
                ,component: DtgManageDangerDriveRuleMainComponent
                ,data: {
                    title: '위험운전설정관리'
                    ,urls: [
                        {
                            title: '메인'
                            ,url:"/dtg/car/current/list"
                        }
                        ,{ title: '위험운전설정관리' }
                    ]
                    ,isShowDateSelector: false
                    ,sideBarType:"menu"
                    ,menuId: "menu-04"
                }
            }
            ,{
                path: "dtg/manage/etas/car/main"
                ,component: DtgManageEtasCarMainComponent
                ,data: {
                    title: 'E-Tas차량관리'
                    ,urls: [
                        {
                            title: '메인'
                            ,url:"/dtg/car/current/list"
                        }
                        ,{ title: 'E-Tas차량관리' }
                    ]
                    ,isShowDateSelector: true
                    ,sideBarType:"menu"
                    ,menuId: "menu-04"
                }
            }
            ,{
                path: "dtg/manage/etas/file/main"
                ,component: DtgManageEtasFileMainComponent
                ,data: {
                    title: 'E-Tas파일관리'
                    ,urls: [
                        {
                            title: '메인'
                            ,url:"/dtg/car/current/list"
                        }
                        ,{ title: 'E-Tas파일관리' }
                    ]
                    ,isShowDateSelector: true
                    ,sideBarType:"menu"
                    ,menuId: "menu-04"
                }
            }
            ,{
                path: "dtg/notice/main"
                ,component: DtgNoticeMainComponent
                ,data: {
                    title: '공지사항'
                    ,urls: [
                        {
                            title: '메인'
                            ,url:"/dtg/car/current/list"
                        }
                        ,{ title: '공지사항' }
                    ]
                    ,isShowDateSelector: false
                    ,sideBarType:"menu"
                    ,menuId: "menu-04"
                }
            }
            ,{
                path: "dtg/manage/notice/main"
                ,component: DtgManageNoticeMainComponent
                ,data: {
                    title: '공지관리'
                    ,urls: [
                        {
                            title: '메인'
                            ,url:"/dtg/car/current/list"
                        }
                        ,{ title: '공지관리' }
                    ]
                    ,isShowDateSelector: false
                    ,sideBarType:"menu"
                    ,menuId: "menu-04"
                }
            }
            ,{
                path: "dtg/packet/realtime"
                ,component: DtgPacketRealtimeComponent
                ,data: {
                    title: '실시간패킷확인'
                    ,urls: [
                        {
                            title: '메인'
                            ,url:"/dtg/car/current/list"
                        }
                        ,{ title: '실시간패킷확인' }
                    ]
                    ,isShowDateSelector: false
                    ,sideBarType:"menu"
                    ,menuId: "menu-05"
                }
            }
            ,{
                path: "dtg/test/t01"
                ,component: DtgTestT01Component
                ,data: {
                    title: 't01'
                    ,urls: [
                        {
                            title: '메인'
                            ,url:"/dtg/car/current/list"
                        }
                        ,{ title: 't01' }
                    ]
                    ,isShowDateSelector: false
                    ,sideBarType:"menu"
                    ,menuId: "menu-05"
                }
            }
            ,{
                path: "dtg/test/t02"
                ,component: DtgTestT02Component
                ,data: {
                    title: 't02'
                    ,urls: [
                        {
                            title: '메인'
                            ,url:"/dtg/car/current/list"
                        }
                        ,{ title: 't02' }
                    ]
                    ,isShowDateSelector: false
                    ,sideBarType:"menu"
                    ,menuId: "menu-05"
                }
            }
            ,{
                path: "dtg/test/t03"
                ,component: DtgTestT03Component
                ,data: {
                    title: 't03'
                    ,urls: [
                        {
                            title: '메인'
                            ,url:"/dtg/car/current/list"
                        }
                        ,{ title: 't03' }
                    ]
                    ,isShowDateSelector: false
                    ,sideBarType:"menu"
                    ,menuId: "menu-05"
                }
            }
            ,{
                path: "dtg/config/system"
                ,component: DtgConfigSystemComponent
                ,data: {
                    title: '환경설정'
                    ,urls: [
                        {
                            title: '메인'
                            ,url:"/dtg/car/current/list"
                        }
                        ,{ title: '환경설정' }
                    ]
                    ,isShowDateSelector: false
                    ,sideBarType:"menu"
                    ,menuId: "menu-05"
                }
            }
        ]
    }
    ,{
        path: '**'
        ,redirectTo: '/fvms/auth/login/main'
    }
];
